<template>
<h5 v-if="dataStore?.data?.num_total === 0 && dataStore.params.mnb !== 'x'">keine Resultate gefunden</h5>
  <table class="result-table table-striped table-hover w-100 table r" v-if="dataStore?.data?.num_items">
    <thead class="container">
      <tr class="row">
        <th class="col-12 col-md-4">Apotheke</th>
        <th class="col-12 col-md-4">Notdienste</th>
        <th class="col-12 col-md-4">Standort</th>
      </tr>
    </thead>
    <tbody class="container">
      <Result v-for="(result, index) in dataStore?.data?.data" :key="result.name || result.name1" :result="result" :index="index" />
    </tbody>
  </table>
</template>

<script setup>
import Result from "@/components/Apothekenfinder/Result";
import { useDataStore } from "@/store/";

const dataStore = useDataStore();
</script>
